// extracted by mini-css-extract-plugin
export default {"title":"CampaignsBarChart_title__DQhlc"};